import React from "react";

export const SocialLinkedIn: React.FC<DogsTrust.IconProps> = ({
	height = "40px",
	width = "40px",
	fillPrimary = "#FFC800",
	fillSecondary = "#222",
	invert,
	...props
}) => {
	return (
		<svg
			aria-hidden="true"
			focusable="false"
			width={width}
			height={height}
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g fill="none" fillRule="evenodd">
				<path
					d="M19.247.093C32.708-1.111 41.26 9.549 39.848 22.339c-.763 8.97-8.305 17.51-17.661 17.657-5.779.074-11.955-.96-16.257-5.122C.96 29.785-1.432 21.957.897 15.12 2.912 6.424 10.385.636 19.247.093"
					fill={invert ? fillSecondary : fillPrimary}
				/>
				<path
					d="M15.0483 28H11.2834V15.8956H15.0483V28ZM13.1456 14.2763C11.9716 14.2763 11 13.2642 11 12.0497C11 11.2805 11.4048 10.5518 12.0526 10.1875C12.7408 9.78267 13.5909 9.78267 14.2386 10.1875C14.9268 10.5518 15.3317 11.2805 15.3317 12.0497C15.3317 13.2642 14.3601 14.2763 13.1456 14.2763ZM29.0959 28H25.3714V22.13C25.3714 20.7131 25.331 18.9318 23.3878 18.9318C21.4446 18.9318 21.1612 20.4297 21.1612 22.0085V28H17.3963V15.8956H20.9993V17.5554H21.0398C21.5661 16.6243 22.7805 15.6122 24.6023 15.6122C28.4077 15.6122 29.1364 18.1222 29.1364 21.3608V28H29.0959Z"
					fill={invert ? fillPrimary : fillSecondary}
					fillRule="nonzero"
				/>
			</g>
		</svg>
	);
};

export default SocialLinkedIn;
